// extracted by mini-css-extract-plugin
export default {"container":"Privacy_container__xcuUb","titleWrapper":"Privacy_titleWrapper__ro-Nw"};